import { get, put } from "@beatbox/voice-core";
const KEY_PREFIX = "best:";
export async function loadBest(courseKey) {
    return (await get("progress", KEY_PREFIX + courseKey)) ?? null;
}
export async function recordRun(courseKey, score, combo) {
    const prev = await loadBest(courseKey);
    const isNewBest = score > 0 && (!prev || score > prev.bestScore);
    const best = {
        bestScore: Math.max(prev?.bestScore ?? 0, score),
        bestCombo: Math.max(prev?.bestCombo ?? 0, combo),
        runs: (prev?.runs ?? 0) + 1,
        updatedAt: Date.now(),
    };
    await put("progress", KEY_PREFIX + courseKey, best);
    console.info(`[progress] recorded run '${courseKey}' score=${score} ` +
        `best=${best.bestScore} runs=${best.runs} newBest=${isNewBest}`);
    return { best, isNewBest };
}
